import cancelEvent from './mini/cancelEvent';


const PopupService = {

    _closeCallbacks: [],

    init: function () {
        document.addEventListener('keyup', (e: any) => {
            if (e.keyCode === 27) {
                cancelEvent(e);
                this.runCb(e);
            }
        });
        document.addEventListener('mousedown', (e: any) => {
            if (e.target?.classList?.contains('react-confirm-alert') ||
                e.target?.classList?.contains('react-confirm-alert-overlay') ||
                e.target?.classList?.contains('outside-click-panel') ||
                e.target?.classList?.contains('overlay-click-wrapper') ||
                e.target?.classList?.contains('overlay')
            ) {
                this.runCb(e);
            }
        });
    },

    listenEscPressed: function (cb) {
        this._closeCallbacks.push(cb);
    },
    stopListenEscPressed: function (cb) {
        for (let i = 0; i < this._closeCallbacks.length; i++) {
            if (this._closeCallbacks[i] === cb) {
                this._closeCallbacks[i] = null;
                break;
            }

        }
        this._closeCallbacks = this._closeCallbacks.filter(cb => !!cb);
    },
    runCb: function (e) {
        const cb = this._closeCallbacks.pop();
        if (cb) {
            cb(e);
        }

    }
};

export default PopupService;